import type { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

/** A place's glyph in a list row: a tinted square, greyed for an archived organization. */
export function PlaceIcon({
  icon: Icon,
  muted,
}: {
  readonly icon: LucideIcon;
  readonly muted?: boolean;
}) {
  return (
    <span
      className={cn('place-row-icon', muted === true && 'place-row-icon-muted')}
      aria-hidden="true"
    >
      <Icon />
    </span>
  );
}
